import React, { useLayoutEffect, useState, Fragment, useEffect, use } from 'react'
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, SelectBox, CheckBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import { PaymentRequestService } from '../../../apis/apiServices/PaymentRequest';
import { Loader } from '../../Shared/PageLoader';
import Swal from 'sweetalert2';
import DataGrid, {
    Column, Editing, Summary, TotalItem,
} from "devextreme-react/data-grid";
import Popup from "devextreme-react/popup";
import { FundRequestService } from '../../../apis/apiServices/FundRequest';


export default function AddEditPaymentReqestComponent(props) {
    const user = useSelector((state) => state.user.data);
    const location = useLocation();
    const navigate = useNavigate();
    debugger
    const { paymentRequestId, IsShowButtons, isMytask } = location.state || {};
    useLayoutEffect(() => {
        const initialize = async () => {
            if (!paymentRequestId) {
                document.querySelector("#pageTitle").innerHTML = "PR - Add Payment Request";
            } else {
                document.querySelector("#pageTitle").innerHTML = "PR - Update Payment Request";
                await getPaymentRequestData(paymentRequestId);
            }
        };
        if (paymentRequestId) {
            getAttachmentsByRequestIdAndRequestTypeId(paymentRequestId, 3);
        }

        initialize();
    }, []);
    const [loading, setLoading] = useState(false)
    const [paymentRequestData, setPaymentRequestData] = useState(null);
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
    const [prAttachmentData, setPRAttachmentData] = useState(null);
    const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);
    const [remarks, setRemarks] = useState(null);
    const [charCount, setCharCount] = useState(0);
    const [error, setError] = useState({});
    const [files, setFiles] = useState([]);
    const [isValidRecomAmt, setIsValidRecomAmt] = useState(false);

    const getPaymentRequestData = async () => {
        try {
            let body = { 'paymentRequestId': paymentRequestId, 'userId': user?.userId }
            const response = await PaymentRequestService.getPaymentRequestDetailsByPRId(body)
            setPaymentRequestData(response?.data);
        } catch (error) {
            console.log("Error getPaymentRequestData===>", error);
        }
    }

    const handleAproveRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleApproveSubmit = async () => {
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        } else {
            setError({ remarks: "", userIdForRejectIOM: "" });
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }


        setIsModalVisible(false);
        setRemarks("");
        setError({});
        let body = {
            modifiedBy: user.userId || 0,
            paymentRequestId: paymentRequestData?.paymentRequestId,
            serialNo: paymentRequestData?.serialNo,
            remarks: remarks || "",
            stageIndex: paymentRequestData?.currentStageIndex,
            items: (paymentRequestData?.items || []).map(item => ({
                itemId: item.itemId || item.id,  // adjust if your object uses `id` instead of `itemId`
                itemSerialNo: item.itemSerialNo || '',
                paidAmt: item.paidAmt || 0
            }))
        };
        setLoading(true)
        const response = await PaymentRequestService.approvePaymentRequest(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })

            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (location?.state?.fromPendingPage === true) {
                navigate(-1);
                //console.log("reduxcount", iomPendingCount);
            } else {
                navigate(-1);
            }
        });
    };

    const handleRejectRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleRejectSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        }

        // if (!userIdForRejectIOM) {
        //     newError.userIdForRejectIOM = "Please select user";
        // }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        // No errors, proceed
        setIsRejectModalVisible(false);
        setRemarks("");
        //setUserIdForRejectIOM(null);
        setError({});


        let body = {
            modifiedBy: user.userId,
            paymentRequestId: paymentRequestData?.paymentRequestId,
            serialNo: paymentRequestData?.serialNo,
            remarks: remarks || "",
            backToStageIndex: 1,
        };
        setLoading(true)
        const response = await PaymentRequestService.rejectPaymentRequest(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            navigate(-1)
        });
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e?.target?.files); // Convert FileList to Array
        setFiles(prevState => [...prevState, ...selectedFiles]);
    };

    const handleFileRemove = (index) => {
        let attachmentToRemove = files?.find((_, i) => i === index)

        setFiles((prev) => prev?.filter((_, i) => i !== index));

        if (attachmentToRemove?.attachmentId) {
            setRemovedAttachmentIds(prevState => {
                let previousIds = prevState || [];
                return [
                    ...previousIds,
                    attachmentToRemove?.attachmentId || 0
                ]
            });
        }
    };

    const addNewPaymentRequest = async (prStatus) => {
        // if (!validateForm()) return false;
        try {
            let requestFormData = new FormData();

            // ✅ Append each field individually
            requestFormData.append("ModifiedBy", user?.userId);
            requestFormData.append("PaymentRequestId", paymentRequestData?.paymentRequestId);
            requestFormData.append("RequestStatusId", prStatus);
            requestFormData.append("SerialNo", paymentRequestData?.serialNo);
            requestFormData.append("Remarks", prStatus === 8 ? "Updated Payment Request" : remarks);
            requestFormData.append("StageIndex", paymentRequestData?.currentStageIndex);
            requestFormData.append("ModifiedFeatureId", props?.featurePermission?.featureId);

            // ✅ Append RemovedAttachmentIds array

            requestFormData.append(`RemovedAttachmentIdsJson`, JSON.stringify(paymentRequestData?.paymentRequestId && (removedAttachmentIds ?? [])));
            requestFormData.append(`ItemsJson`, JSON.stringify((paymentRequestData?.items || []).map(item => ({
                itemId: item.itemId || item.id,  // adjust if your object uses `id` instead of `itemId`
                itemSerialNo: item.itemSerialNo || '',
                paidAmt: item.paidAmt || 0
            }))));

            // ✅ Append files
            files.forEach((file) => {
                requestFormData.append("Documents", file);
            });

            setLoading(true)
            const response = paymentRequestId ? await PaymentRequestService.updatePaymentRequest(requestFormData) : await PaymentRequestService.addPaymentRequest(requestFormData)
            setLoading(false)
            if (response?.isSuccess) {

                Swal.fire("", response?.message, "success")
                    .then(() => {
                        navigate(-1);
                    });
            } else {
                Swal.fire("Error", response?.message, "error")
            }
        }
        catch (error) {
            console.log("Error addEitPaymentRequest===>", error);
        }
    }

    const getButtonText = () => {
        if (!Array.isArray(paymentRequestData?.actionDetails) || paymentRequestData?.actionDetails?.length === 0) return "Send";

        const actionTypeId = paymentRequestData?.actionDetails[1]?.statusId;

        if (actionTypeId === 2) return "Send for Recommendation";
        if (actionTypeId === 7) return "Send for Verification";

        return "Send";
    };

    const getAttachmentsByRequestIdAndRequestTypeId = async (requestId, requestTypeId) => {
        //debugger
        try {
            const response = await FundRequestService.getRequestAttachmentsByRequestId(requestId, requestTypeId);
            let arr = []
            response?.data?.map((item, key) => {
                let obj = {
                    attachmentId: item?.attachmentId,
                    filePath: item?.filePath,
                    name: item?.fileName,
                    size: item?.fileSize,
                    type: item?.fileType
                }
                arr.push(obj)
            })
            setFiles(arr);

        } catch (error) {
            console.log("Error getAttachmentsByRequestIdAndRequestTypeId===>", error);
        }
    }


    //console.log("paymentRequestData", paymentRequestData)
    return (
        <Fragment>
            <div className="content">
                <div className='card top-bottom' >
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-8 col-md-6 col-sm-12'>
                                {IsShowButtons &&
                                    <>
                                        {/* <Button
                                            text={paymentRequestData?.nextStageActionType ? paymentRequestData?.nextStageActionType : "Send for Approval"}
                                            icon="check"
                                            onClick={() => {
                                                // ✅ Validate if any item has paidAmt = 0
                                                const hasZeroPaidAmt = (paymentRequestData?.items || []).some(
                                                    (item) => Number(item.paidAmt) === 0
                                                );

                                                if (hasZeroPaidAmt) {
                                                    Swal.fire(
                                                        "Amount Limit Warning!",
                                                        "Payment amount cannot be 0 for any vendor.",
                                                        "warning"
                                                    );
                                                    return;
                                                }

                                                // 🔹 Validation: Check if any paidAmt > recommendedAmt
                                                const hasOverpaidItem = paymentRequestData?.items.some(
                                                    item => Number(item.paidAmt) > Number(item.recommendedAmt)
                                                );

                                                if (hasOverpaidItem) {
                                                    Swal.fire(
                                                        "Amount Limit Warning!",
                                                        "Payment amount cannot be greater than the recommended amount for any item.",
                                                        "warning"
                                                    );
                                                    return;
                                                }

                                                setIsModalVisible(true);
                                            }}
                                            visible={paymentRequestData?.currentUserId === user?.userId && paymentRequestData?.isApproved === false}
                                            stylingMode="default"
                                            type="success"
                                            className="mr-2"
                                        /> */}
                                        {(!paymentRequestData?.requestStatusId === 8 || !paymentRequestData?.requestStatusId === 15 || !paymentRequestData?.requestStatusId === 4) &&
                                            <Button
                                                text="Back to Draft"
                                                icon="back"
                                                visible={paymentRequestData?.createdByUserId !== user?.userId && paymentRequestData?.currentUserId === user?.userId && paymentRequestData?.isApproved === false}
                                                onClick={async () => {
                                                    // if (iomData?.reviewerStatusId === 10) {
                                                    //     Swal.fire({
                                                    //         icon: 'info',
                                                    //         title: 'Pending for Review',
                                                    //         text: 'This IOM is still pending for review.',
                                                    //     });
                                                    //     return; // stop here so it doesn't go to confirm dialog
                                                    // }

                                                    const confirmResult = await Swal.fire({
                                                        title: "Are you sure?",
                                                        text: "Do you want to send the Payment Request back to draft?",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Yes, continue",
                                                        cancelButtonText: "No, cancel"
                                                    });

                                                    if (confirmResult.isConfirmed) {
                                                        setIsRejectModalVisible(true);
                                                    }
                                                }}
                                                stylingMode="default"
                                                type="danger"
                                                className="mr-2"
                                                hint="Back to Draft"
                                            />
                                        }
                                        {(paymentRequestData?.requestStatusId === 8 || paymentRequestData?.requestStatusId === 15 || paymentRequestData?.requestStatusId === 4) &&
                                            <>
                                                <Button
                                                    text="Save as Draft"
                                                    icon="save"
                                                    onClick={() => {
                                                        // ✅ Validate if any item has paidAmt = 0
                                                        const hasZeroPaidAmt = (paymentRequestData?.items || []).some(
                                                            (item) => Number(item.paidAmt) === 0
                                                        );

                                                        if (hasZeroPaidAmt) {
                                                            Swal.fire(
                                                                "Amount Limit Warning!",
                                                                "Payment amount cannot be 0 for any vendor.",
                                                                "warning"
                                                            );
                                                            return;
                                                        }

                                                        // 🔹 Validation: Check if any paidAmt > recommendedAmt
                                                        const hasOverpaidItem = paymentRequestData?.items.some(
                                                            item => Number(item.paidAmt) > Number(item.recommendedAmt)
                                                        );

                                                        if (hasOverpaidItem) {
                                                            Swal.fire(
                                                                "Amount Limit Warning!",
                                                                "Payment amount cannot be greater than the recommended amount for any item.",
                                                                "warning"
                                                            );
                                                            return;
                                                        }

                                                        let prStatus = 8
                                                        addNewPaymentRequest(prStatus);
                                                    }}

                                                    stylingMode="contained"
                                                    type="default"
                                                    hint='Save as Draft'
                                                />
                                                &nbsp;&nbsp;
                                                <Button
                                                    text={getButtonText()}
                                                    icon="check"
                                                    onClick={() => {
                                                        // ✅ Validate if any item has paidAmt = 0
                                                        const hasZeroPaidAmt = (paymentRequestData?.items || []).some(
                                                            (item) => Number(item.paidAmt) === 0
                                                        );

                                                        if (hasZeroPaidAmt) {
                                                            Swal.fire(
                                                                "Amount Limit Warning!",
                                                                "Payment amount cannot be 0 for any vendor.",
                                                                "warning"
                                                            );
                                                            return;
                                                        }

                                                        // 🔹 Validation: Check if any paidAmt > recommendedAmt
                                                        const hasOverpaidItem = paymentRequestData?.items.some(
                                                            item => Number(item.paidAmt) > Number(item.recommendedAmt)
                                                        );

                                                        if (hasOverpaidItem) {
                                                            Swal.fire(
                                                                "Amount Limit Warning!",
                                                                "Payment amount cannot be greater than the recommended amount for any item.",
                                                                "warning"
                                                            );
                                                            return;
                                                        }

                                                        setIsModalVisible(true);
                                                    }}
                                                    stylingMode="contained"
                                                    type="default"
                                                    hint='Send for approval'
                                                />
                                            </>
                                        }
                                    </>
                                }
                                {isMytask && paymentRequestData?.requestStatusId !== 15 &&
                                    <>
                                        <Button
                                            text="Save"
                                            icon="save"
                                            onClick={() => {
                                                // ✅ Validate if any item has paidAmt = 0
                                                const hasZeroPaidAmt = (paymentRequestData?.items || []).some(
                                                    (item) => Number(item.paidAmt) === 0
                                                );

                                                if (hasZeroPaidAmt) {
                                                    Swal.fire(
                                                        "Amount Limit Warning!",
                                                        "Payment amount cannot be 0 for any vendor.",
                                                        "warning"
                                                    );
                                                    return;
                                                }

                                                // 🔹 Validation: Check if any paidAmt > recommendedAmt
                                                const hasOverpaidItem = paymentRequestData?.items.some(
                                                    item => Number(item.paidAmt) > Number(item.recommendedAmt)
                                                );

                                                if (hasOverpaidItem) {
                                                    Swal.fire(
                                                        "Amount Limit Warning!",
                                                        "Payment amount cannot be greater than the recommended amount for any item.",
                                                        "warning"
                                                    );
                                                    return;
                                                }
                                                setIsSaveModalVisible(true);
                                                //let prStatus = 5
                                                //addNewPaymentRequest(prStatus);
                                            }}

                                            stylingMode="contained"
                                            type="default"
                                            hint='Save'
                                        />
                                    </>
                                }
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Back"
                                    icon="back"
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Back'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className={'col-lg-12 col-md-12'}>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="hugeicons:file-02" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Request No.</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.serialNo}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:date-range-outline-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Created On</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.createdOn}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Site</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.projectName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Department</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.departmentName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="tabler:category-2" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Category</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.categoryName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-6 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:subject-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Subject</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.subject}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card' >
                            <div className='card-body'>
                                <DataGrid
                                    dataSource={paymentRequestData?.items || []}
                                    columnAutoWidth
                                    showBorders
                                    showRowLines
                                    showColumnLines={false}
                                    noDataText="No details"
                                    className='selectable-grid'
                                    onCellValueChanged={(e) => {
                                        if (e.column.dataField === "paidAmt") {
                                            // update your state when payment amount changes
                                            const updatedItems = paymentRequestData?.items?.map(item =>
                                                item.id === e.key ? { ...item, paymentAmt: e.value } : item
                                            );
                                            setPaymentRequestData(prev => ({ ...prev, items: updatedItems }));
                                        }
                                    }}
                                >
                                    {/* enable editing */}
                                    <Editing mode="cell" allowUpdating={true} />
                                    {/* <Selection mode="multiple" showCheckBoxesMode="always" /> */}
                                    {/* <Column
                                        caption=""
                                        width={50}
                                        cellRender={({ data }) => {
                                            return (
                                                <>
                                                    {(!paymentRequestData.isApproved && paymentRequestData?.currentUserId === user?.userId) ?
                                                        <span title="" onClick={() => deleteFundRequestItem(data)} >
                                                            <Icon icon="material-symbols:delete-outline-rounded" className='iconify-style'
                                                            />
                                                        </span>
                                                        :
                                                        <span title="" >
                                                            <Icon icon="material-symbols:delete-outline-rounded" className='iconify-style'
                                                                style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                            />
                                                        </span>
                                                    }
                                                </>
                                            )
                                        }}
                                    /> */}
                                    <Column dataField="itemSerialNo" caption="Sr no." allowEditing={false} />
                                    <Column dataField="vendorName" caption="Vendor" allowEditing={false} />
                                    <Column dataField="bankName" caption="Bank" allowEditing={false} />
                                    <Column
                                        dataField="balanceAmt"
                                        caption="Ledger Balance"
                                        allowEditing={false}
                                        cellRender={({ data }) => {
                                            const value = data.balanceAmt;
                                            return (
                                                <span>
                                                    {value === null || value === undefined
                                                        ? "-"
                                                        : `Rs. ${value.toLocaleString("en-IN")}`}
                                                </span>
                                            );
                                        }}
                                    />

                                    <Column
                                        dataField="recommendedAmt"
                                        caption="Recommended Amt."
                                        allowEditing={false}
                                        cellRender={({ data }) => {
                                            const value = data.recommendedAmt;
                                            return (
                                                <span>
                                                    {value === null || value === undefined
                                                        ? "-"
                                                        : `Rs. ${value.toLocaleString("en-IN")}`}
                                                </span>
                                            );
                                        }}
                                    />

                                    {/* Editable Payment Amount */}
                                    <Column
                                        dataField="paidAmt"
                                        caption="Payment Amt."
                                        dataType="number"
                                        format="#,##0.##"
                                        allowEditing={true}
                                        editorOptions={{
                                            min: 0,
                                            placeholder: "Enter amount",
                                        }}
                                        cellRender={({ data }) => {
                                            const value = data.paidAmt || 0;
                                            const recommendedAmt = data.recommendedAmt || 0;
                                            const isInvalid = recommendedAmt > 0 && value > recommendedAmt;

                                            return (
                                                <div style={{ textAlign: "right" }}>
                                                    {value === 0 || value === null || value === undefined ? (
                                                        <span style={{ color: "silver" }}>Enter amount</span>
                                                    ) : (
                                                        <span style={{ color: "#333" }}>
                                                            Rs. {value.toLocaleString("en-IN")}
                                                        </span>
                                                    )}
                                                    {isInvalid && (
                                                        <div
                                                            style={{
                                                                color: "red",
                                                                fontSize: "11px",
                                                                marginTop: "2px",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                                background: "#fff6f6",
                                                                borderRadius: "4px",
                                                                padding: "2px 4px",
                                                                display: "block",
                                                                lineHeight: "1.2",
                                                            }}
                                                        >
                                                            Payment amount cannot be greater than the recommended amount.
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />



                                    <Column dataField="remarks" caption="Remarks" visible={false} />
                                    {/* ✅ Summary Row for Totals */}
                                    <Summary>
                                        <TotalItem
                                            column="balanceAmt"
                                            summaryType="sum"
                                            customizeText={(e) =>
                                                e.value
                                                    ? `Rs. ${e.value.toLocaleString("en-IN")}`
                                                    : "Rs. 0"
                                            }
                                        />
                                        <TotalItem
                                            column="recommendedAmt"
                                            summaryType="sum"
                                            customizeText={(e) =>
                                                e.value
                                                    ? `Rs. ${e.value.toLocaleString("en-IN")}`
                                                    : "Rs. 0"
                                            }
                                        />
                                        <TotalItem
                                            column="paidAmt"
                                            summaryType="sum"
                                            customizeText={(e) =>
                                                e.value
                                                    ? `Rs. ${e.value.toLocaleString("en-IN")}`
                                                    : "Rs. 0"
                                            }
                                        />
                                    </Summary>

                                </DataGrid>
                                <div className="row mt-4">
                                    {paymentRequestData?.actionDetails?.map((stage, index) => (
                                        <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                            <div className="w-100">
                                                <label className="form-label">{stage?.status} By,</label>
                                                {stage?.approvers?.map((approver, i) => (
                                                    <input
                                                        key={i}
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={`${approver?.firstName + " " + approver?.lastName} (${approver?.designation})`}
                                                        readOnly
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* Attachment */}
                        {IsShowButtons && (
                            <div className='mb-1' style={{ marginTop: "15px" }}>
                                <div className="form-group">{/* <span onClick={() => { console.log(files) }}>console</span> */}
                                    <label htmlFor="fileUpload" className='btn btn-outline-primary mb-1' style={{ cursor: 'pointer' }} title='Attachment'> <i class="fas fa-plus"></i> Attachment </label>
                                    <input
                                        id="fileUpload"
                                        type="file"
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}
                                    />
                                </div>
                                <div className='attachment-container'>
                                    {files?.map((file, idx) => (
                                        <div
                                            key={idx}
                                            className='attachment-item'
                                        >
                                            <div class="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}>
                                                <div className='attachment-name'
                                                    onClick={() => {
                                                        if (file?.filePath) {
                                                            const fileUrl =
                                                                process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                                                file?.filePath;
                                                            window.open(fileUrl, '_blank');
                                                        }
                                                    }}>
                                                    {file?.name}
                                                </div>
                                                <button
                                                    className='btn pt-0 pb-0 pr-0'
                                                    onClick={() => handleFileRemove(idx)}
                                                >
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                            <div className='small'>
                                                {(file?.size / 1024).toFixed(0)}kb
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className='web-page-footer'>
                    www.vishwasamudra.in
                </div>
            </div>
            {/* Approval PopUp */}
            <Popup
                visible={isModalVisible}
                onHiding={() => setIsModalVisible(false)}
                showTitle={true}
                title="Approval"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarks}
                            onInput={(e) => handleAproveRemarksChange(e)}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={300}
                        />
                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                            {charCount}/300 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>

                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={() => {
                            addNewPaymentRequest(0);
                            setIsModalVisible(false);
                        }}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {/* Save PopUp */}
            <Popup
                visible={isSaveModalVisible}
                onHiding={() => setIsSaveModalVisible(false)}
                showTitle={true}
                title="Save"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarks}
                            onInput={(e) => handleAproveRemarksChange(e)}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={300}
                        />
                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                            {charCount}/300 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>

                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsSaveModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={() => {
                            addNewPaymentRequest(5);
                            setIsSaveModalVisible(false);
                        }}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {/* Reject PopUp */}
            <Popup
                visible={isRejectModalVisible}
                onHiding={() => setIsRejectModalVisible(false)}
                dragEnabled={false}
                showTitle={true}
                title="Back to Draft"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Sent to <span className="text-danger">*</span></label>
                        <div>
                            <SelectBox
                                dataSource={paymentRequestData?.actionDetails?.find(f => f.stageIndex === 1)?.approvers}
                                valueExpr="userId"
                                displayExpr={(item) =>
                                    item ? `${item?.firstName} ${item?.lastName} (${item?.designation})` : ""
                                }
                                className="form-control"
                                placeholder="Select user"
                                searchEnabled
                                disabled={true}
                                showClearButton={true}
                                value={paymentRequestData?.createdByUserId}
                            // onValueChanged={(e) => {
                            //     setUserIdForRejectIOM(e.value);
                            // }}
                            //onValueChanged={(e) => handleUserRejectChange(e)}
                            />
                            {error.userIdForRejectIOM && (
                                <div style={{ color: "red" }}>{error.userIdForRejectIOM}</div>
                            )}
                        </div>
                    </div>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <div>
                            <TextArea
                                value={remarks}
                                onInput={(e) => handleRejectRemarksChange(e)}
                                height={90}
                                placeholder="Type your remarks..."
                                maxLength={300}
                            />
                            <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                {charCount}/300 characters
                            </div>
                            {error.remarks && (
                                <div style={{ color: "red" }}>{error.remarks}</div>
                            )}
                        </div>
                    </div>


                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsRejectModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleRejectSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {loading && <Loader loadingMessage={""} />}
        </Fragment>
    )
}
